import { useOne } from "@/hooks/useResourceOne";
import { useBasicComponents } from "../useBasicComponent";
import { useResourceUpdate } from "@/hooks/useResourceUpdate";

export const usePoolHadoopConfig = (id) => {
  const { mutateAsync, isLoading: isSaving } = useResourceUpdate();
  const { data, isLoading, isError } = useOne({
    skip: !id,
    meta: {
      op: 'hadoop',
    },
  });

  const { replicas, core, memory, version, dataDisk, logDisk, workerMem } = useBasicComponents();

  return {
    isLoading,
    isSaving,
    save: async (data) => {
      if (!id || !data) return;
      return await mutateAsync({ values: data });
    },
    value: (isLoading || isError) ? {} : { hadoop: data?.hadoop },
    schema: [
      {
        type: 'array',
        title: "",
        dataIndex: "hadoop",
        colProps: { span: 24, xs: 24, sm: 24, md: 24 },
        fields: [
          [
            replicas({
              dataIndex: 'replicas',
              width: 'sm',
              colProps: { xs: 24, sm:8 },
            }),
            core({
              dataIndex: 'core',
              width: 'sm',
              colProps: { xs: 24, sm:8 },
            }),
            memory({
              dataIndex: 'memory',
              width: 'sm',
              colProps: { xs: 24, sm:8 },
            }),
            version({
              dataIndex: 'version',
              width: 'sm',
              colProps: { xs: 24, sm:8 },
            }),
            {
              valueType: 'dependency',
              name: ['name'],
              columns: ({ name }) => {
                if (['spark-master', 'spark-master-proxy', 'hadoop-nn-proxy'].indexOf(name) === -1) {
                  return [dataDisk({
                    dataIndex: 'dataDisk',
                    width: 'sm',
                    colProps: { xs: 24, sm:8 },
                  })];
                } else {
                  return [];
                }
              }
            },
            {
              valueType: 'dependency',
              name: ['name'],
              columns: ({ name }) => {
                if (name === 'zookeeper') {
                  return [logDisk({
                    dataIndex: 'logDisk',
                    width: 'sm',
                    colProps: { xs: 24, sm:8 },
                  })];
                } else {
                  return [];
                }
              }
            },
            {
              valueType: 'dependency',
              name: ['name'],
              columns: ({ name }) => {
                if (name === 'spark-worker') {
                  return [workerMem({
                    dataIndex: 'workerMem',
                    width: 'sm',
                    colProps: { xs: 24, sm:8 },
                  })];
                } else {
                  return [];
                }
              }
            },
          ],
        ],
      },
    ],
  };
};